/*
 * Module for Conversation Variable list administration
 */
define([
  "marionette",
  "messaging/messenger",
  "backbone",
  "./conversationVariablesAdminView",
  "modules/shared/sortableList/sortableListModule",
  "modules/authoringAdmin/conversationVariablesModal/conversationVariablesModalModule",
  "modules/shared/conversationVariables/conversationVariablesModel",
], function (
  Marionette,
  Messenger,
  Backbone,
  ConversationVariablesAdminView,
  SortableListModule,
  ConversationVariablesModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "conversationVariables";
      this.region = options.region;
      this._setUpReqRes();
      this._setUpVents();
    },
    show: function () {
      //set no-op save
      Messenger.onSave(function () {
        console.log("saving conversation variable");
        Messenger.saveAttempted(true);
      }, this);

      const headers = Messenger.reqres.request("conversationVariables:config:headers");
      this.conversationVariables = Messenger.reqres.request("conversation:variables");
      this.layout = new ConversationVariablesAdminView.conversationVariablesLayout();

      const extendedEvents = {
        "click #deleteConversationVariable": function () {
          Messenger.yesNoDialog(
            "admin.conversationVariable.confirmDeleteConversationVariable",
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Conversation Variable",
                  id: this.model.id,
                  idType: "Conversation Variable",
                  object: "Conversation Variable",
                });
                this.model.deleteModel();
              },
            },
            this,
          );
        },
      };
      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          namespace: this.name,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          extendedEvents: extendedEvents,
        }),
      );

      this.layout.on(
        "add:conversationVariable",
        function () {
          const newItem = this.conversationVariables.addItem();
          //show the conversation variables config modal
          Messenger.vent.trigger(
            "show:modal",
            ConversationVariablesModalModule,
            {
              editMode: false,
            },
            newItem,
            {
              title: "admin.conversationVariable.addConversationVariable",
              closeButton: false,
              closeOnBackgroundClick: false,
              modalWidth: 550,
              trackInteraction: {
                action: "Add Conversation Variable",
                object: "Conversation Variable",
              },
            },
          );
        },
        this,
      );

      this.layout.on(
        "show",
        function () {
          this.conversationVariables.onSynced(function () {
            this.list.show(this.conversationVariables);
          }, this);
          //this.list.show(this.conversationVariables);
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _setUpVents: function () {
      //Show the conversation variables admin screen
      Messenger.vent.on(
        "show:authoring:admin:conversationVariables",
        function () {
          const kbId = Messenger.reqres.request("active:kb");
          Backbone.history.navigate(kbId + "/authoringAdmin/conversationVariables");
          this.show();
        },
        this,
      );
      // a row was selected in the sortable list (prepend namespace)
      Messenger.vent.on(
        this.name + ":selected:row",
        function (model) {
          Messenger.vent.trigger(
            "show:modal",
            ConversationVariablesModalModule,
            {
              editMode: true,
            },
            model,
            {
              title: "admin.conversationVariable.editConversationVariable",
              closeButton: false,
              closeOnBackgroundClick: false,
              modalWidth: 550,
              trackInteraction: {
                action: "Edit Conversation Variable",
                id: model.id,
                idType: "Conversation Variable",
                object: "Conversation Variable",
              },
            },
          );
        },
        this,
      );
      // show the module
      Messenger.vent.on(
        "show:kb:admin:conversationVariables",
        function () {
          const kbId = Messenger.reqres.request("active:kb");
          Backbone.history.navigate(kbId + "/authoringAdmin/conversationVariables");
          this.show();
        },
        this,
      );
    },
    _setUpReqRes: function () {
      /*
      Messenger.reqres.setHandler("conversation:variables", function(){
        return this.conversationVariables;
      }, this);*/
    },
  });
});
